import { API } from '@/api';
import {
  COMPARISON_OPERATORS,
  DecoratedCompany,
  DecoratedInvestor,
  FILTER_TYPES,
  IsReadFilter,
  type UndecoratedProfile,
} from '@flemingmetrics/api-client';

export async function searchProfiles(query: string, pageSize = 25) {
  const search = query.toLowerCase().trim();
  if (search.length === 0) return [] as UndecoratedProfile[];
  const leads = await API.Profiles.fetchMatchingProfiles({
    search: query,
    fields: ['firstname', 'lastname'],
    filters: [],
    pagination: { page: 1, pageSize },
  });
  return leads.results;
}

export async function searchInvestors(query: string, pageSize = 25) {
  const search = query.toLowerCase().trim();
  if (search.length === 0) return [] as DecoratedInvestor[];
  const investors = await API.Investors.fetchMatchingInvestors({
    search: query,
    fields: ['firstname', 'lastname'],
    filters: [],
    pagination: { page: 1, pageSize },
  });
  return investors.results;
}

export async function searchCompanies(query: string, pageSize = 25) {
  const search = query.toLowerCase().trim();
  if (search.length === 0) return [] as DecoratedCompany[];
  const companies = await API.Companies.fetchMatchingCompanies({
    search: query,
    fields: ['name'],
    filters: [],
    pagination: { page: 1, pageSize },
  });
  return companies.results;
}

export function buildIdFilter(ids: number[]) {
  return {
    filterType: FILTER_TYPES.COLUMN_VALUE,
    column: 'id',
    comparisonOperator: COMPARISON_OPERATORS.IN.value,
    value: ids,
  };
}

export function buildIsReadFilter(isRead: boolean): IsReadFilter {
  return {
    filterType: FILTER_TYPES.COLUMN_VALUE,
    column: 'isRead',
    comparisonOperator: COMPARISON_OPERATORS.IS.value,
    value: isRead,
  };
}
